import { S3Client } from '@aws-sdk/client-s3';
import { AuthSendType } from '../../../Components/Auth/context/context';
import { getEssentialCredentials } from '../credentials';

export const getS3Client = async (send?: AuthSendType) => {
  const credentials = await getEssentialCredentials(send);
  const client = new S3Client({ region: 'eu-west-1', credentials });
  return client;
};
